import axios from 'axios'
import qs from 'qs'
// import {Loading, Message} from 'element-ui'
import { Message } from 'element-ui'
import myLocalStorage from './myLocalStorage'
// loading
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
// 从localStorage中获取token
const logPre = 'DEBUG :-  '
const errorColor = 'color: rgb(248, 77, 73);'
const successColor = 'color: rgb(18, 135, 114);'
const logColor = 'color: rgb(0, 100, 155)'
const requestColor = 'color: rgb(200, 100, 10)'

function getLocalToken () {
  const token = myLocalStorage.getData('dydnz_access_token')
  return token
}
function getRefreshToken () {
  return myLocalStorage.getData('dydnz_refresh_token')
}
// 创建一个axios实例
const instance = axios.create({
  timeout: 300000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
})
// online
instance.prototype.$apiSLD = '/nezha-api'
// instance.prototype.$uiSLD = 'console.'
// instance.prototype.$wwwSLD = 'www.'
// const contextPath = '/nezha-api'
let NEZHA_ENV = process.env.NEZHA_ENV
console.log(NEZHA_ENV)
switch (NEZHA_ENV) {
  case 'test':
    instance.prototype.$protocol = 'http'
    instance.prototype.$domain = '192.168.30.73:9777'
    // instance.prototype.$domain = '192.168.30.29:9777'
    instance.prototype.$callBackHost = '192.168.30.73:9909'
    break
  case 'pro':
    instance.prototype.$protocol = 'https'
    instance.prototype.$domain = 'nezha.daoyoudao.com'
    instance.prototype.$callBackHost = 'nezha.daoyoudao.com'
    break
  case 'dev':
    instance.prototype.$protocol = 'http'
    instance.prototype.$domain = 'dev'
    instance.prototype.$callBackHost = '192.168.30.73:9909'

    break
  default:
    // 本地开发环境
    instance.prototype.$protocol = 'http'
    instance.prototype.$domain = 'test.nezha.daoyoudao.com'
    // 文涛
    // instance.prototype.$domain = '192.168.80.17:9777'
    // 李凯
    // instance.prototype.$domain = '192.168.80.137:9777'
    // instance.prototype.$domain = 'nezhaapi.free.idcfengye.com'
    // instance.prototype.$domain = '10.8.0.3:9777'
    // 秀东
    // instance.prototype.$domain = '192.168.42.203:9777'
    // instance.prototype.$domain = 'xiudong.free.idcfengye.com'
    // instance.prototype.$domain = '192.168.200.118:9777'
    // 测试
    instance.prototype.$domain = '192.168.30.73:9777'
    // instance.prototype.$domain = '192.168.42.203:9777'
    // instance.prototype.$domain = '192.168.80.153:9777'
    // 明珠
    // instance.prototype.$domain = '192.168.81.42:9777'
    // instance.prototype.$domain = 'mmm.free.idcfengye.com'
    // instance.prototype.$domain = '192.168.80.67:9777'
    // 刘松
    // instance.prototype.$domain = '192.168.20.47:9777'
    // instance.prototype.$callBackHost = '192.168.30.73:9909'
    // 郭泽琪
    // instance.prototype.$domain = '192.168.42.75:9777'
    break
}
instance.defaults.baseURL = instance.prototype.$protocol + '://' + instance.prototype.$domain + instance.prototype.$apiSLD
// console.log(instance.defaults.baseURL)

// 给实例添加一个setToken方法，用于登录后将最新token动态添加到header，同时将token保存在localStorage中
instance.setToken = token => {
  instance.defaults.headers['Authorization'] = 'Bearer ' + token
  myLocalStorage.setData('dydnz_access_token', token, 60)
}

// 是否正在刷新的标记
let isRefreshing = false
// 重试队列，每一项将是一个待执行的函数形式
let waitingRequests = []
// , '/api/account/'  '/api/enterprise/',
let urlPrefix = ['/api/operation/rule/', '/api/project/', '/api/role/', '/api/creativeComponent/getAccountListByProjectId', '/api/directional/getAccountList4Select']
// 不需添加字段的url
let filterUrl = ['/api/project/deleteAssignedAccount', '/api/operation/rule/uploadExcel']
// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    // NProgress.start()
    // NProgress.done()
    if (config.method === 'post' && config.url === '/api/auth/login') {
      config.data = qs.stringify(config.data)
    }
    if (config.url === '/api/auth/token') {
      config.isRefreshOp = true
      config.headers.Authorization = 'Bearer ' + getRefreshToken()
    } else {
      config.isRefreshOp = false
      config.headers.Authorization = 'Bearer ' + getLocalToken() // headers塞token
      let flag = filterUrl.some(item => {
        return item === config.url
      })
      let result = false
      if (!flag) {
        result = urlPrefix.some(item => {
          return config.url.startsWith(item)
        })
      }
      if (result) {
        console.log('interceptors', config.url)
        if (config.data) {
          if (config.data instanceof Object) {
            config.data.platformType = parseInt(localStorage.platformType)
          }
        } else {
          config.data = {}
          config.data.platformType = parseInt(localStorage.platformType)
        }
      }
    }
    NProgress.start()
    console.log(
      '\n%c' +
        logPre +
        config.url +
        ' ➤➤ http begin! ⬇⬇⬇ \n➤➤ http request - data(jsonStr)- :',
      logColor
    )
    console.log('%c' + JSON.stringify(config.data, null, '\t'), requestColor)
    // console.log('%c' + logPre + config.url + ' http request - token : \n' + config.headers.Authorization, logColor)
    return config
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
  }
)
// 拦截返回数据处理
instance.interceptors.response.use(
  response => {
    NProgress.done()
    console.log(
      '\n%c' +
        logPre +
        response.config.url.replace(response.config.baseURL, '') +
        ' ➤➤ http response success & data(jsonStr)- :',
      logColor
    )
    console.log('%c' + JSON.stringify(response.data, null, '\t'), successColor)
    console.log(
      '%c' +
        logPre +
        response.config.url.replace(response.config.baseURL, '') +
        ' ➤➤ http end! ⬆⬆⬆\n',
      logColor
    )
    return response.data
  },
  error => {
    NProgress.done()
    console.log(error)
    if (!error.response) {
      return Message({
        type: 'warning',
        center: true,
        showClose: true,
        customClass: 'httpError',
        iconClass: 'el-icon-warning',
        message: error
      })
    }
    let httpStatus = error.response.status
    if (error.response.config.isRefreshOp) {
      // 是刷新token 接口 单独的处理逻辑
      console.log('刷新接口异常 或者 401 重新登录操作')
      window.location.href = '/'
      myLocalStorage.removeData('dydnz_access_token')
      myLocalStorage.removeData('dydnz_refresh_token')
    } else {
      console.log(
        '\n%c' +
          logPre +
          error.response.config.url.replace(error.response.config.baseURL, '') +
          ' ➤➤ http response error & code:' +
          httpStatus +
          ' & data(jsonStr)- :',
        logColor
      )
      console.log(
        '%c' + JSON.stringify(error.response.data, null, '\t'),
        errorColor
      )
      console.log(
        '%c' +
          logPre +
          error.response.config.url.replace(error.response.config.baseURL, '') +
          ' ➤➤ http end! ⬆⬆⬆\n',
        logColor
      )
      if (httpStatus === 401) {
        // 过期
        const config = error.response.config // 错误请求的 config
        if (!isRefreshing) {
          isRefreshing = true
          return refreshToken()
            .then(res => {
              const { token } = res.result
              instance.setToken(token)
              config.headers['Authorization'] = 'Bearer ' + token
              // 已经刷新了token，将所有队列中的请求进行重试
              waitingRequests.forEach(cb => cb(token))
              waitingRequests = []
              return instance(config)
            })
            .finally(() => {
              isRefreshing = false
            })
        } else {
          // 正在刷新token，将返回一个未执行resolve的promise
          return new Promise(resolve => {
            // 将resolve放进队列，用一个函数形式来保存，等token刷新后直接执行
            waitingRequests.push(token => {
              config.headers['Authorization'] = 'Bearer ' + token
              resolve(instance(config))
            })
          })
        }
      } else if (httpStatus === 400) {
        // 参数错误
        Message({
          type: 'warning',
          center: true,
          showClose: true,
          customClass: 'httpError',
          iconClass: 'el-icon-warning',
          message: error.response.data.message
        })
      } else if (httpStatus === 403) {
        Message({
          type: 'warning',
          center: true,
          showClose: true,
          customClass: 'httpError',
          iconClass: 'el-icon-warning',
          message: error.response.data.message
        })
      } else if (httpStatus === 500) {
        if (error.response.data.code === 6006015 || error.response.data.code === 6006017 || error.response.data.code === 6006018 || error.response.data.code === 6006111) {
          Message({
            message: error.response.data.message,
            type: 'error'
          })
        } else {
          Message({
            type: 'error',
            center: true,
            showClose: true,
            duration: 10000,
            customClass: 'httpError',
            iconClass: 'el-icon-warning',
            message: error.response.data.message
          })
          if (error.response.data.code === 6001013) {
            window.location.href = '/'
            myLocalStorage.removeData('dydnz_access_token')
            myLocalStorage.removeData('dydnz_refresh_token')
          }
        }
      } else {
        Message({
          type: 'error',
          center: true,
          showClose: true,
          duration: 15000,
          customClass: 'httpError',
          iconClass: 'el-icon-warning',
          message: error.response.data.message
        })
      }
    }
    return Promise.reject(error.response.data)
  }
)

function refreshToken () {
  return instance.get('/api/auth/token').then(res => res)
}

export default instance



// WEBPACK FOOTER //
// ./src/config/axios.js